
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-mdi-chevron-down",
  "use": "icon-mdi-chevron-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-mdi-chevron-down\"><path d=\"M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-mdi-chevron-down"/>
                </svg>
            );
        };

        Icon.id = "icon-mdi-chevron-down";

        export default Icon;
    